import { getWavelength } from "@/services/weather_data/service";

export const wavelengthModule = {
  namespaced: true,

  state: () => ({
    wavelength: [],
    loading: false,
    error: null,
  }),

  getters: {
    wavelength: (state) => state.wavelength,
    wavelengthLoading: (state) => state.loading,
    wavelengthError: (state) => state.error,
  },

  mutations: {
    SET_WAVELENGTH(state, value) {
      state.wavelength = value;
    },

    SET_LOADING(state, value) {
      state.loading = value;
    },

    SET_ERROR(state, value) {
      state.error = value;
    },
  },

  actions: {
    async fetchWavelength({ commit }, { vesselName, startDate, stopDate }) {
      commit("SET_LOADING", true);
      commit("SET_ERROR", null);

      try {
        const data = await getWavelength(vesselName, startDate, stopDate);
        commit("SET_WAVELENGTH", data);
        return data;
      } catch (error) {
        commit("SET_WAVELENGTH", []);
        commit("SET_ERROR", error.message || "Could not fetch wavelength");
        return [];
      } finally {
        commit("SET_LOADING", false);
      }
    },
  },
};
